import { Suspense } from "react";

import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import LogRocket from 'logrocket';

import App from "./App";
import { rootStore } from "./store";
import { persistor } from "store/root.store";
import "common/assets/styles/root.css";
import "common/assets/styles/main.scss";

if (process.env.NODE_ENV !== 'production') {
  try {
    LogRocket.init('okwygo/ben-baa-fe');
  } catch (error) {
    console.warn('LogRocket initialization failed:', error);
  }
}

const container = document.getElementById("root")!;
(window as any).version = "baafull-10-28";
const root = createRoot(container);
root.render(
  <Provider store={ rootStore }>
    <PersistGate loading={ null } persistor={ persistor }>
      <Suspense fallback={ null }>
        <App />
      </Suspense>
    </PersistGate>
  </Provider>,
);
